import React from "react";
import PropTypes from "prop-types";

import Size from "components/Size";
import TitledLabel from "components/TitledLabel";
import { objectValueNotZero } from "utils";
import kFormatter from "utils/kFormatter";
import Restricted from "utils/Restricted";
import Translate from "utils/translate";

import styles from "./PortfolioStatistics.css";

const { t } = new Translate("PortfolioStatistics");

const PortfolioStatistics = (props) => {
  const {
    isBroker,
    isLarge,
    onMarket,
    onMarketPct,
    rentableArea,
    totalAssetLeads,
    totalAssets,
    totalDeals,
    totalDemand,
  } = props;

  const sizeUnit = rentableArea && rentableArea.unit;

  const market = objectValueNotZero(onMarket) && (
    <Size
      isLarge={props.isLarge}
      unit={sizeUnit}
      value={onMarketPct}
      value2={kFormatter(onMarket.value)}
    />
  );

  const assetLeads = <Size isLarge={isLarge} value={kFormatter(totalAssetLeads)} />;

  const assets = (
    <Size
      isLarge={isLarge}
      primaryValue="value2"
      unit={!isBroker && objectValueNotZero(rentableArea) ? sizeUnit : ""}
      value={kFormatter(totalAssets)}
      value2={!isBroker ? kFormatter(rentableArea.value) : ""}
    />
  );

  const deals = (
    <Size
      isLarge={isLarge}
      primaryValue="value2"
      unit={objectValueNotZero(totalDemand) ? sizeUnit : ""}
      value={kFormatter(totalDeals)}
      value2={kFormatter(totalDemand.value)}
    />
  );

  return (
    <div className={styles.root}>
      {isLarge ? (
        <div className={styles.large}>
          <Restricted requiredPermissions="asset_leads">
            <TitledLabel text={assetLeads || "-"} title={t("assetLeads")} isLarge />
          </Restricted>
          <Restricted requiredPermissions="assets">
            <TitledLabel text={assets || "-"} title={t("assets")} isLarge />
            {!isBroker && <TitledLabel text={market || "-"} title={t("onMarket")} isLarge />}
          </Restricted>
          <Restricted requiredPermissions="deals">
            <TitledLabel text={deals || "-"} title={t("deals")} isLarge />
          </Restricted>
        </div>
      ) : (
        <Restricted requiredPermissions="assets">
          <div className={styles.small}>
            <div>
              {kFormatter(props.totalAssets)} {t("assets")}
            </div>
            {!isBroker && market && (
              <div>
                {market} {t("onMarket")}
              </div>
            )}
          </div>
        </Restricted>
      )}
    </div>
  );
};

PortfolioStatistics.propTypes = {
  onMarket: PropTypes.shape({
    value: PropTypes.number,
    unit: PropTypes.string,
  }),
  onMarketPct: PropTypes.string,
  totalDemand: PropTypes.shape({
    value: PropTypes.number,
    unit: PropTypes.string,
  }),
  rentableArea: PropTypes.shape({
    value: PropTypes.number,
    unit: PropTypes.string,
  }),
  totalAssets: PropTypes.number,
  totalAssetLeads: PropTypes.number,
  totalDeals: PropTypes.number,
  isBroker: PropTypes.bool,
  isLarge: PropTypes.bool,
};

PortfolioStatistics.defaultProps = {
  totalAssetLeads: 0,
  totalDeals: 0,
  totalDemand: { value: 0, unit: "" },
  onMarket: { value: 0, unit: "" },
  rentableArea: { value: 0, unit: "" },
};

export default PortfolioStatistics;
